export interface AmplifyError {
  code: string;
  message: string;
  name: string;
}

export interface AmplifyErrorParsed {
  code: string;
  message: string;
  name: string;
  details: string;
}

export const parseAmplifyError = (err: AmplifyError): AmplifyErrorParsed => {
  let errMsg = "";

  switch (err.code) {
    case "UserNotFoundException":
      errMsg = "User not found";
      break;

    default:
      errMsg = err.message;
  }

  return {
    ...err,
    details: errMsg
  };
};
